export default __webpack_public_path__ + "static/soups-9c24b549427c468102a3ae5e1e41c4a3.jpg";